import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { format } from 'date-fns';
import { nb } from 'date-fns/locale';

interface TimeSeriesChartProps {
  data: Array<{
    date: string;
    successCount: number;
    errorCount: number;
    avgSourcesFound: number;
    avgExecutionTime: number;
  }>;
}

export function TimeSeriesChart({ data }: TimeSeriesChartProps) {
  const formattedData = data.map(d => ({
    ...d,
    displayDate: format(new Date(d.date), 'dd.MM', { locale: nb }),
  }));

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Kjøringer over tid</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={formattedData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="displayDate" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="successCount" stroke="hsl(var(--primary))" name="Suksess" />
              <Line type="monotone" dataKey="errorCount" stroke="hsl(var(--destructive))" name="Feil" />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Snitt kilder funnet</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={formattedData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="displayDate" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line 
                type="monotone" 
                dataKey="avgSourcesFound" 
                stroke="hsl(var(--primary))" 
                name="Snitt kilder" 
              />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
}
